export type SitecoreImageField = {
  value: {
    src: string;
    alt: string;
    width: string;
    height: string;
  };
};

export type TimelineTableRow = {
  id: string;
  fields: {
    Title: { value: string };
    Speakers: { value: string };
    Description: { value: string };
    StartTime: { value: string };
    EndTime: { value: string };
  };
};

export type TimelineTab = {
  id: string;
  displayName?: string;
  name?: string;
  fields: {
    TabTitle: { value: string };
    TabTableRows: TimelineTableRow[];
  };
};

export type TimelineWithTabsAndTableFields = {
  Title: { value: string };
  TitleHeaderLabel: { value: string };
  SpeakersHeaderLabel: { value: string };
  SpeakersCellIcon: SitecoreImageField;
  DescriptionHeaderLabel: { value: string };
  TimeHeaderLabel: { value: string };
  TimeCellIcon: SitecoreImageField;
  Tabs: TimelineTab[];
  SectionBackgroundColor: { value: string };
  SectionTemplate: {
    fields: {
      Title: { value: string };
    };
  };
  ScrollToText?: { value: string };
  isScrollAllowed?: { value: boolean };
};

export type TimelineWithTabsAndTableCo = {
  id: string;
  displayName: string;
  fields: TimelineWithTabsAndTableFields;
};
